module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shouye"
  }, [_c('div', {
    staticClass: "navList"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "navList-item",
      on: {
        "click": function($event) {
          return _vm.handleNav(index)
        }
      }
    }, [_c('span', {
      class: _vm.navListIndex === index ? 'navList-item-span' : 'navList-item-span1'
    }, [_vm._v(_vm._s(item.categoryName))]), _vm._v(" "), _c('span', {
      class: _vm.navListIndex === index ? 'navList-item-xian' : 'navList-item-xian1'
    })])
  }), 0), _vm._v(" "), _c('div', {
    ref: "listContainer",
    staticClass: "list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('div', {
    staticClass: "list-box"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('zbList', {
      key: index,
      attrs: {
        "data": item
      }
    })
  }), 1), _vm._v(" "), (_vm.isKong) ? _c('kong') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-153b4e68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/shouye/shouye.vue
// module id = 957
// module chunks = 1